application.register("layout_footer", class extends Stimulus.Controller {
    scrollTop() {
        if(typeof locomotive !== "undefined") {
            locomotive.scrollTo(0,0);
        }
        else {
            document.documentElement.scroll({top: 0});
        }
    }
});